(() => {
  let cleanup;
  const initialize = () => {
    cleanup?.();
    const controller = new AbortController();
    const timers = new Set();
    const observers = [];
    const listen = (target, event, handler, options = {}) => target?.addEventListener(event, handler, {...options, signal: controller.signal});
    const repeat = (handler, delay) => { const timer = setInterval(handler, delay); timers.add(timer); return timer; };
    const observe = (...args) => { const observer = new IntersectionObserver(...args); observers.push(observer); return observer; };
    cleanup = () => {  controller.abort(); timers.forEach(clearInterval); observers.forEach(observer => observer.disconnect()); };

  const bookAwardSource=document.body.dataset.bookAwardSrc;
  if(bookAwardSource){
    document.querySelectorAll('.history-book .mini-book-copy h3').forEach(heading=>{
      if(heading.classList.contains('book-callout-heading'))return;
      const title=document.createElement('span');
      title.className='book-callout-title';
      title.append(...heading.childNodes);
      const award=document.createElement('img');
      award.className='book-callout-award';
      award.src=bookAwardSource;
      award.alt=document.body.dataset.bookAwardAlt||'';
      award.width=200;award.height=183;award.loading='lazy';
      heading.classList.add('book-callout-heading');
      heading.append(title,award);
    });
  }


  // Discourage casual image saving without changing gallery or link activation.
  const imageSurface = target => target instanceof Element && (
    target.closest('img, image, .framed-photo, .horse-mark, .bottle-stage, .archive-category-media, .detail-photo-trigger, .reference-image-stage, .gallery-thumb, .hero-bottle-original') ||
    target.closest('svg')?.querySelector('image')
  );
  document.querySelectorAll('img').forEach(image => { image.draggable = false; });
  listen(document, 'contextmenu', event => {
    if (imageSurface(event.target)) event.preventDefault();
  });
  listen(document, 'dragstart', event => {
    const imageLink = event.target instanceof Element && event.target.closest('a')?.querySelector('img, image');
    if (imageSurface(event.target) || imageLink) event.preventDefault();
  });
  const heroPhoto = document.querySelector('.hero-bottle-original');
  if (heroPhoto) {
    // Position using layout coordinates so the original remains an ordinary image.
    const positionHeroPhoto = () => {
      const offset = heroPhoto.getBoundingClientRect().width * 0.6;
      heroPhoto.style.setProperty('--hero-photo-offset', `${offset}px`);
    };
    positionHeroPhoto();
    new ResizeObserver(positionHeroPhoto).observe(heroPhoto);
  }
  const bottles = window.WAREHOUSE_BOTTLES || [];
  const guides = [{name:'The History of Blanton’s',slug:'history',keywords:'1982 1984 distillery ferdie falk robert bob baranaskas elmer lee single barrel launch advertisements'},{name:'My Personal Collection',slug:'personal-collection',keywords:'dominic guglielmi collection rare bottles basement bar photographs video'},{name:'Warehouse H Rarity Index',slug:'rarity-index',keywords:'rarity index definitions common uncommon rare exceptionally unicorn obtainability'},{name:'The Horse and Jockey Stopper',slug:'stoppers',keywords:'stopper stoppers horse jockey letters stave'},{name:'Boxes & Packaging',slug:'boxes',keywords:'box boxes packaging gift coffin derby'},{name:'Blanton’s Hang Tags',slug:'hang-tags',keywords:'hang tag tags booklet booklets paper history'}];
  const escape = value => String(value).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const searchText = b => [b.name,b.category,b.proof,b.years,b.market,b.rarity,b.story,...b.notes,...(b.collector_notes||[])].join(' ').normalize('NFKD').toLowerCase();
  const matches = (b,q) => q.toLowerCase().trim().split(/\s+/).every(term => searchText(b).includes(term));
  const dialog = document.querySelector('#search-dialog');
  const globalSearch = document.querySelector('#global-search');
  const globalResults = document.querySelector('#global-results');
  let trigger;
  const showGlobalResults = () => {
    const q = globalSearch.value.trim();
    const selected = bottles.filter(b=>matches(b,q)).slice(0,8);
    const book = !q || /book|signed|warehouse|hardcover|dominic/i.test(q);
    globalResults.innerHTML = (book ? '<a class="search-result" href="/book/"><div><strong>Warehouse H · The Book</strong><small>260 pages · Hardcover · Author signed</small></div><span class="arrow" aria-hidden="true">→</span></a>' : '') + selected.map(b=>`<a class="search-result" href="/bottles/${escape(b.slug)}/"><div><strong>${escape(b.name)}</strong><small>${escape(b.proof_label || (String(b.proof).toLowerCase()==='varies' ? 'Proof varies' : b.proof+' proof'))} · ${escape(b.market)}</small></div><span class="arrow" aria-hidden="true">→</span></a>`).join('');
    const guideMatches=guides.filter(g=>q.toLowerCase().split(/\s+/).every(term=>(g.name+' '+g.keywords).toLowerCase().includes(term)));
    globalResults.innerHTML+=guideMatches.map(g=>`<a class="search-result" href="/${g.slug}/"><div><strong>${escape(g.name)}</strong><small>Collector guide</small></div><span class="arrow" aria-hidden="true">→</span></a>`).join('');
    globalResults.querySelectorAll('a[href]').forEach(a=>{const next=window.WAREHOUSE_ROUTE_URLS?.[a.getAttribute('href')];if(next)a.href=next;});
    if(!globalResults.children.length) globalResults.innerHTML='<p class="search-hint">No results in this preview selection. Try “Gold”, “Japan” or “book”.</p>';
  };
  document.querySelectorAll('[data-open-search]').forEach(button=>listen(button, 'click',()=>{trigger=button;dialog.showModal();showGlobalResults();globalSearch.focus();}));
  listen(document.querySelector('[data-close-search]'), 'click',()=>dialog.close());
  listen(dialog, 'click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
  listen(dialog, 'close',()=>trigger?.focus());
  listen(globalSearch, 'input',showGlobalResults);
  const photoDialog = document.querySelector('#photo-dialog');
  const gallery = document.querySelector('[data-gallery]');
  const thumbnails = [...document.querySelectorAll('[data-gallery-index]')];
  let photoIndex = 0;
  const photoZoomStage = photoDialog?.querySelector('[data-photo-zoom-stage]');
  const updatePhotoZoom = () => {
    const full = photoDialog?.querySelector('#photo-full');
    if (!photoZoomStage || !full) return;
    full.style.removeProperty('width');
    full.style.removeProperty('height');
    const zoom = window.matchMedia('(min-width: 901px)').matches ? Number(thumbnails[photoIndex]?.dataset.desktopZoom || 1) : 1;
    photoZoomStage.dataset.zoom = String(zoom);
    if (photoDialog.open && zoom > 1) {
      const frame = JSON.parse(thumbnails[photoIndex].dataset.frame);
      const [, , width, height] = frame.view_box;
      const bounds = photoZoomStage.getBoundingClientRect();
      const scale = Math.min(bounds.width / width, bounds.height / height) * zoom;
      full.style.width = `${width * scale}px`;
      full.style.height = `${height * scale}px`;
    }
    photoZoomStage.scrollTop = 0;
    photoZoomStage.scrollLeft = 0;
  };
  if (photoZoomStage) listen(window, 'resize', updatePhotoZoom);
  const selectPhoto = index => {
    if (!thumbnails.length) return;
    photoIndex = (index + thumbnails.length) % thumbnails.length;
    const selected = thumbnails[photoIndex];
    for (const id of ['bottle-main-photo','photo-full']) {
      const image = document.getElementById(id);
      if (image?.tagName.toLowerCase()==='svg') {
        const frame=JSON.parse(selected.dataset.frame);
        image.setAttribute('viewBox',frame.view_box.join(' '));
        image.setAttribute('aria-label',selected.dataset.alt);
        const source=image.querySelector('image');
        source.setAttribute('href',selected.dataset.src);
        source.setAttribute('width',frame.source_size[0]);
        source.setAttribute('height',frame.source_size[1]);
      } else if (image) {image.src=selected.dataset.src;image.alt=selected.dataset.alt;}
    }
    for (const id of ['bottle-photo-caption','photo-full-caption']) {
      const caption=document.getElementById(id);
      if (caption) caption.textContent=selected.dataset.caption;
    }
    thumbnails.forEach((thumb,i)=>thumb.setAttribute('aria-pressed',String(i===photoIndex)));
    const count=document.querySelector('#gallery-count');
    if(count)count.textContent=`${photoIndex+1} / ${thumbnails.length}`;
    updatePhotoZoom();
  };
  thumbnails.forEach((thumb,i)=>listen(thumb, 'click',()=>selectPhoto(i)));
  document.querySelectorAll('[data-gallery-step]').forEach(button=>listen(button, 'click',()=>selectPhoto(photoIndex+Number(button.dataset.galleryStep))));
  const galleryKeys=event=>{
    if(!thumbnails.length||!['ArrowLeft','ArrowRight'].includes(event.key))return;
    event.preventDefault();selectPhoto(photoIndex+(event.key==='ArrowRight'?1:-1));
  };
  listen(gallery, 'keydown',galleryKeys);
  listen(photoDialog, 'keydown',galleryKeys);
  let photoTrigger;
  listen(document.querySelector('[data-open-photo]'), 'click',event=>{photoTrigger=event.currentTarget;photoDialog.showModal();updatePhotoZoom();});
  listen(document.querySelector('[data-close-photo]'), 'click',()=>photoDialog.close());
  listen(photoDialog, 'close',()=>photoTrigger?.focus());
  listen(photoDialog, 'click',event=>{if(event.target===photoDialog){const r=photoDialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)photoDialog.close();}});
  const referenceDialog=document.querySelector('#reference-photo-dialog');
  const referenceButtons=[...document.querySelectorAll('[data-reference-photo]')];
  const collectionPhotos=referenceDialog?.hasAttribute('data-reference-gallery')?referenceButtons.filter(button=>!referenceDialog.dataset.referenceGallerySelector||button.matches(referenceDialog.dataset.referenceGallerySelector)):[];
  let referenceTrigger,referenceIndex=0;
  const showReferencePhoto=button=>{
    const full=document.querySelector('#reference-photo-full');
    full.src=button.dataset.src;full.alt=button.dataset.alt;
    const caption=document.querySelector('#reference-photo-caption');
    if(caption)caption.textContent=button.dataset.caption;
    referenceIndex=collectionPhotos.indexOf(button);
    referenceDialog.querySelectorAll('[data-reference-controls]').forEach(controls=>{controls.hidden=referenceIndex<0;});
    const count=document.querySelector('#reference-photo-count');
    if(count)count.textContent=`${referenceIndex+1} / ${collectionPhotos.length}`;
  };
  const stepReferencePhoto=step=>{
    if(!collectionPhotos.length||referenceIndex<0)return;
    referenceIndex=(referenceIndex+step+collectionPhotos.length)%collectionPhotos.length;
    showReferencePhoto(collectionPhotos[referenceIndex]);
  };
  referenceButtons.forEach(button=>listen(button, 'click',()=>{
    referenceTrigger=button;
    showReferencePhoto(button);
    referenceDialog.showModal();
  }));
  document.querySelectorAll('[data-reference-step]').forEach(button=>listen(button, 'click',()=>stepReferencePhoto(Number(button.dataset.referenceStep))));
  listen(referenceDialog, 'keydown',event=>{
    if(!referenceDialog.open||!collectionPhotos.length||referenceIndex<0||!['ArrowLeft','ArrowRight'].includes(event.key))return;
    event.preventDefault();stepReferencePhoto(event.key==='ArrowRight'?1:-1);
  });
  const swipeStage=referenceDialog?.querySelector('[data-reference-swipe]');
  let swipeStart;
  listen(swipeStage, 'touchstart',event=>{
    swipeStart=event.touches.length===1?{x:event.touches[0].clientX,y:event.touches[0].clientY}:null;
  },{passive:true});
  listen(swipeStage, 'touchend',event=>{
    if(swipeStart&&referenceDialog.open&&event.changedTouches.length){
      const dx=event.changedTouches[0].clientX-swipeStart.x,dy=event.changedTouches[0].clientY-swipeStart.y;
      if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)*1.25)stepReferencePhoto(dx<0?1:-1);
    }
    swipeStart=null;
  },{passive:true});
  listen(swipeStage, 'touchcancel',()=>{swipeStart=null;},{passive:true});
  listen(document.querySelector('[data-close-reference]'), 'click',()=>referenceDialog.close());
  listen(referenceDialog, 'close',()=>referenceTrigger?.focus());
  listen(referenceDialog, 'click',event=>{if(event.target===referenceDialog){const r=referenceDialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)referenceDialog.close();}});
  listen(document.querySelector('[data-share-bottle]'), 'click',async()=>{
    const status=document.querySelector('[data-share-status]');
    try {
      await navigator.clipboard.writeText(location.href);
      status.textContent='Bottle link copied.';
    } catch {
      status.textContent='Copy the address from your browser to share this bottle.';
    }
  });
  const reducedMotion=window.matchMedia('(prefers-reduced-motion: reduce)');
  const praiseCarousel=document.querySelector('[data-praise-carousel]');
  if(praiseCarousel){
    const slides=[...praiseCarousel.querySelectorAll('.praise-slide')];
    const dots=[...praiseCarousel.querySelectorAll('[data-praise-index]')];
    const pause=praiseCarousel.querySelector('[data-praise-pause]');
    const slideRegion=praiseCarousel.querySelector('.praise-slides');
    let index=0,paused=reducedMotion.matches,hovering=false,timer;
    const show=next=>{
      index=(next+slides.length)%slides.length;
      slides.forEach((slide,i)=>{slide.setAttribute('aria-hidden',String(i!==index));slide.inert=i!==index;});
      dots.forEach((dot,i)=>dot.setAttribute('aria-pressed',String(i===index)));
    };
    const sync=()=>{
      clearInterval(timer);
      const rotating=!paused&&!hovering&&!document.hidden;
      pause.textContent=paused?'Start rotation':'Pause rotation';
      slideRegion.setAttribute('aria-live',rotating?'off':'polite');
      if(rotating)timer=repeat(()=>show(index+1),12000);
    };
    praiseCarousel.querySelectorAll('[data-praise-step]').forEach(button=>listen(button, 'click',()=>{show(index+Number(button.dataset.praiseStep));sync();}));
    dots.forEach((dot,i)=>listen(dot, 'click',()=>{show(i);sync();}));
    listen(pause, 'click',()=>{paused=!paused;sync();});
    listen(praiseCarousel, 'mouseenter',()=>{hovering=true;sync();});
    listen(praiseCarousel, 'mouseleave',()=>{hovering=false;sync();});
    listen(praiseCarousel, 'focusin',()=>{paused=true;sync();});
    listen(document, 'visibilitychange',sync);
    listen(reducedMotion, 'change',event=>{if(event.matches){paused=true;sync();}});
    sync();
  }
  const films=[...document.querySelectorAll('[data-film]')];
  const filmButtons=[...document.querySelectorAll('[data-video-toggle]')];
  films.forEach(video=>{
    const button=filmButtons.find(b=>b.dataset.videoToggle===video.id);
    const sync=()=>{if(button)button.textContent=video.paused?'Play video':'Pause video';};
    listen(video, 'play',()=>{video.dataset.started='true';video.dataset.userPaused='false';sync();});
    listen(video, 'pause',()=>{if(video.dataset.autoPausing==='true')delete video.dataset.autoPausing;else if(video.dataset.started==='true')video.dataset.userPaused='true';sync();});
    listen(video, 'error',()=>{if(button)button.textContent='Retry video';});
    listen(button, 'click',()=>{
      if(video.paused){video.dataset.userPaused='false';video.play().catch(()=>{button.textContent='Try play again';});}
      else {video.dataset.userPaused='true';video.pause();}
    });
  });
  if('IntersectionObserver' in window){
    const observer=observe(entries=>entries.forEach(({target:video,isIntersecting})=>{
      if(isIntersecting){if(!reducedMotion.matches&&video.dataset.userPaused!=='true')video.play().catch(()=>{});}
      else if(!video.paused){video.dataset.autoPausing='true';video.pause();}
    }),{threshold:.35});
    films.forEach(video=>observer.observe(video));
  }
  listen(reducedMotion, 'change',event=>{if(event.matches)films.forEach(video=>video.pause());});
  listen(document, 'click',event=>document.querySelectorAll('.archive-menu[open]').forEach(menu=>{if(!menu.contains(event.target))menu.open=false;}));
  listen(document, 'keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.archive-menu[open],.mobile-menu[open]').forEach(menu=>menu.open=false);});
  const grid=document.querySelector('#archive-grid');
  if(grid){
    const controls=['query','category','market','sort'].map(id=>document.getElementById(id));
    const [query,category,market,sort]=controls;
    const params=new URLSearchParams(location.search);
    controls.forEach(c=>{if(params.has(c.id)){const value=params.get(c.id);if(c.tagName==='INPUT'||[...c.options].some(o=>o.value===value))c.value=value;}});
    const archiveScope=document.querySelector('[data-wh-archive-category]')?.dataset.whArchiveCategory||'';
    if(archiveScope){category.value=archiveScope;category.closest('.field').hidden=true;}
    const cards=[...grid.querySelectorAll('[data-bottle]')];
    const availableSlugs=new Set(cards.map(c=>c.dataset.bottle));
    const available=bottles.filter(b=>availableSlugs.has(b.slug)&&(!archiveScope||b.category===archiveScope));
    const empty=document.querySelector('#archive-empty');
    const collectionNav=document.querySelector('.archive-collection-links');
    const sectionLinks=[...document.querySelectorAll('.archive-collection-links [data-archive-category]')];
    const filter=()=>{
      const currentCategory=collectionNav?.dataset.currentCategory||category.value;
      sectionLinks.forEach(link=>link.hidden=link.dataset.archiveCategory===currentCategory);
      const selected=available.filter(b=>matches(b,query.value)&&(!category.value||b.category===category.value)&&(!market.value||b.region===market.value));
      const order=sort.value;
      if(order==='name')selected.sort((a,b)=>a.name.localeCompare(b.name));
      if(order==='oldest')selected.sort((a,b)=>(a.year ?? Infinity)-(b.year ?? Infinity)||a.name.localeCompare(b.name));
      if(order==='newest')selected.sort((a,b)=>(b.year ?? -Infinity)-(a.year ?? -Infinity)||a.name.localeCompare(b.name));
      cards.forEach(c=>c.hidden=true);
      selected.forEach(b=>{const c=cards.find(c=>c.dataset.bottle===b.slug);c.hidden=false;grid.append(c);});
      empty.hidden=selected.length!==0;grid.append(empty);
      document.querySelector('#result-count').textContent=`${selected.length} of ${available.length} archive entries`;
      const next=new URLSearchParams(location.search);['query','category','market','sort'].forEach(key=>next.delete(key));controls.forEach(c=>{if(c.value&&!(c.id==='sort'&&c.value==='featured')&&!(c===category&&archiveScope))next.set(c.id,c.value);});
      history.replaceState(null,'',location.pathname+(next.size?'?'+next:''));
    };
    controls.forEach(c=>listen(c, c.tagName==='INPUT'?'input':'change',filter));
    document.querySelectorAll('[data-reset-filters]').forEach(b=>listen(b, 'click',()=>{controls.forEach(c=>c.value=c.id==='sort'?'featured':c===category?archiveScope:'');filter();query.focus();}));
    filter();
  }

  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', () => cleanup?.());
})();

